"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// Profiles — Netflix-style, within one account.
// Addons stay shared across profiles; library and watch progress are per profile.
//
// Switching works because the authKey carries the profile server-side: we ask
// our backend for the target profile's token, then dispatch
// Ctx::Authenticate(LoginWithToken), which makes stremio-core re-authenticate
// and re-sync the library under that profile. No password, no logout.
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var core_1 = require("stremio/core");
var components_1 = require("stremio/components");
var common_1 = require("stremio/common");
var components_2 = require("../components");
// @ts-expect-error - plain JS module
var ProfileAvatar_1 = __importDefault(require("stremio/common/ProfileAvatar"));
// @ts-expect-error - plain JS module
var selfHostProfiles_1 = require("stremio/common/selfHostProfiles");
var Profiles_less_1 = __importDefault(require("./Profiles.less"));
var API_BASE = 'https://my.stremio.chanclatoen.nl/api';
function api(method, body) {
    return __awaiter(this, void 0, void 0, function () {
        var res, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("".concat(API_BASE, "/").concat(method), {
                        method: 'POST',
                        headers: { 'content-type': 'application/json' },
                        body: JSON.stringify(body),
                    })];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    data = _a.sent();
                    if (data.error)
                        throw new Error(data.error.message);
                    return [2 /*return*/, data.result];
            }
        });
    });
}
var Profiles = (0, react_1.forwardRef)(function (_a, ref) {
    var _b, _c;
    var profile = _a.profile;
    var t = (0, react_i18next_1.useTranslation)().t;
    var core = (0, core_1.useCore)();
    var toast = (0, common_1.useToast)();
    var _d = (0, react_1.useState)([]), profiles = _d[0], setProfiles = _d[1];
    var _e = (0, react_1.useState)(null), active = _e[0], setActive = _e[1];
    var _f = (0, react_1.useState)(''), newName = _f[0], setNewName = _f[1];
    var _g = (0, react_1.useState)(false), busy = _g[0], setBusy = _g[1];
    var _h = (0, react_1.useState)(null), picking = _h[0], setPicking = _h[1];
    // the logged-in session's key, as stremio-core holds it
    var authKey = (_c = (_b = profile === null || profile === void 0 ? void 0 : profile.auth) === null || _b === void 0 ? void 0 : _b.key) !== null && _c !== void 0 ? _c : null;
    var load = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var r, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!authKey)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, api('profilesList', { authKey: authKey })];
                case 2:
                    r = _a.sent();
                    setProfiles(r.profiles);
                    setActive(r.active);
                    (0, selfHostProfiles_1.refresh)(authKey);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    toast.show({ type: 'error', title: 'Profiles', message: e_1.message, timeout: 4000 });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [authKey]);
    (0, react_1.useEffect)(function () { load(); }, [load]);
    var create = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var name, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    name = newName.trim();
                    if (!name)
                        return [2 /*return*/];
                    setBusy(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, api('profileCreate', { authKey: authKey, name: name })];
                case 2:
                    _a.sent();
                    setNewName('');
                    return [4 /*yield*/, load()];
                case 3:
                    _a.sent();
                    toast.show({ type: 'success', title: 'Profiles', message: "Created \u201C".concat(name, "\u201D"), timeout: 3000 });
                    return [3 /*break*/, 6];
                case 4:
                    e_2 = _a.sent();
                    toast.show({ type: 'error', title: 'Profiles', message: e_2.message, timeout: 4000 });
                    return [3 /*break*/, 6];
                case 5:
                    setBusy(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [authKey, newName, load]);
    var rename = (0, react_1.useCallback)(function (p) { return __awaiter(void 0, void 0, void 0, function () {
        var name, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    name = window.prompt("Rename \u201C".concat(p.name, "\u201D to:"), p.name);
                    if (!name || name === p.name)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, api('profileRename', { authKey: authKey, profileId: p.id, name: name })];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, load()];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_3 = _a.sent();
                    toast.show({ type: 'error', title: 'Profiles', message: e_3.message, timeout: 4000 });
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [authKey, load]);
    var remove = (0, react_1.useCallback)(function (p) { return __awaiter(void 0, void 0, void 0, function () {
        var e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!window.confirm("Delete \u201C".concat(p.name, "\u201D and its library?\n\nThis cannot be undone.")))
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, api('profileDelete', { authKey: authKey, profileId: p.id })];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, load()];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_4 = _a.sent();
                    toast.show({ type: 'error', title: 'Profiles', message: e_4.message, timeout: 4000 });
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [authKey, load]);
    var setAvatar = (0, react_1.useCallback)(function (profileId, avatar) { return __awaiter(void 0, void 0, void 0, function () {
        var e_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, api('profileSetAvatar', { authKey: authKey, profileId: profileId, avatar: avatar })];
                case 1:
                    _a.sent();
                    setPicking(null);
                    return [4 /*yield*/, load()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_5 = _a.sent();
                    toast.show({ type: 'error', title: 'Profiles', message: e_5.message, timeout: 4000 });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [authKey, load]);
    // Resize client-side before upload: the image is stored as a data URI in
    // SQLite and read on every profilesList, so a full-size photo would bloat
    // every menu open. 128px webp keeps it a few KB.
    var uploadAvatar = (0, react_1.useCallback)(function (profileId, file) {
        if (!file.type.startsWith('image/')) {
            toast.show({ type: 'error', title: 'Profiles', message: 'That is not an image', timeout: 4000 });
            return;
        }
        var reader = new FileReader();
        reader.onload = function () {
            var img = new Image();
            img.onload = function () {
                var S = 128;
                var canvas = document.createElement('canvas');
                canvas.width = S;
                canvas.height = S;
                var ctx = canvas.getContext('2d');
                // cover-crop to a square so faces don't get squashed
                var scale = Math.max(S / img.width, S / img.height);
                var w = img.width * scale, h = img.height * scale;
                ctx.drawImage(img, (S - w) / 2, (S - h) / 2, w, h);
                var out = canvas.toDataURL('image/webp', 0.85);
                if (!out.startsWith('data:image/webp'))
                    out = canvas.toDataURL('image/png');
                setAvatar(profileId, out);
            };
            img.onerror = function () { return toast.show({ type: 'error', title: 'Profiles', message: 'Could not read that image', timeout: 4000 }); };
            img.src = String(reader.result);
        };
        reader.readAsDataURL(file);
    }, [setAvatar]);
    var switchTo = (0, react_1.useCallback)(function (p) { return __awaiter(void 0, void 0, void 0, function () {
        var token, e_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (p.id === active)
                        return [2 /*return*/];
                    setBusy(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, api('profileSwitch', { authKey: authKey, profileId: p.id })];
                case 2:
                    token = (_a.sent()).token;
                    // hand the profile token to the core; it re-authenticates and
                    // re-syncs the library for that profile
                    core.transport.dispatch({
                        action: 'Ctx',
                        args: {
                            action: 'Authenticate',
                            args: { type: 'LoginWithToken', token: token },
                        },
                    });
                    toast.show({ type: 'success', title: 'Profiles', message: "Switched to \u201C".concat(p.name, "\u201D"), timeout: 3000 });
                    return [3 /*break*/, 5];
                case 3:
                    e_6 = _a.sent();
                    toast.show({ type: 'error', title: 'Profiles', message: e_6.message, timeout: 4000 });
                    return [3 /*break*/, 5];
                case 4:
                    setBusy(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [authKey, active, core]);
    if (!authKey) {
        return (react_1.default.createElement(components_2.Section, { ref: ref, label: 'Profiles' },
            react_1.default.createElement("div", { className: Profiles_less_1.default['empty'] }, "Sign in to use profiles.")));
    }
    return (react_1.default.createElement(components_2.Section, { ref: ref, label: 'Profiles' },
        react_1.default.createElement("div", { className: Profiles_less_1.default['hint'] }, "Each profile keeps its own library and watch progress. Addons are shared across all of them."),
        react_1.default.createElement("div", { className: Profiles_less_1.default['list'] },
            profiles.map(function (p) { return (react_1.default.createElement("div", { key: p.id, className: Profiles_less_1.default['row'] },
                react_1.default.createElement("button", { className: Profiles_less_1.default['avatar-button'], title: 'Change avatar', onClick: function () { return setPicking(picking === p.id ? null : p.id); } },
                    react_1.default.createElement(ProfileAvatar_1.default, { profile: p, size: 40 })),
                react_1.default.createElement("div", { className: Profiles_less_1.default['meta'] },
                    react_1.default.createElement("div", { className: Profiles_less_1.default['name'] },
                        p.name,
                        p.id === active && react_1.default.createElement("span", { className: Profiles_less_1.default['badge'] }, "active"),
                        p.isDefault && react_1.default.createElement("span", { className: Profiles_less_1.default['badge-muted'] }, "default"))),
                react_1.default.createElement("div", { className: Profiles_less_1.default['actions'] },
                    p.id !== active &&
                        react_1.default.createElement(components_1.Button, { className: Profiles_less_1.default['btn'], disabled: busy, onClick: function () { return switchTo(p); } }, "Switch"),
                    react_1.default.createElement(components_1.Button, { className: Profiles_less_1.default['btn'], onClick: function () { return rename(p); } }, "Rename"),
                    !p.isDefault && p.id !== active &&
                        react_1.default.createElement(components_1.Button, { className: Profiles_less_1.default['btn-danger'], onClick: function () { return remove(p); } }, "Delete")))); }),
            picking !== null &&
                react_1.default.createElement("div", { className: Profiles_less_1.default['picker'] },
                    react_1.default.createElement("div", { className: Profiles_less_1.default['picker-title'] }, "Choose an avatar"),
                    react_1.default.createElement("div", { className: Profiles_less_1.default['picker-grid'] }, selfHostProfiles_1.PRESETS.map(function (preset) { return (react_1.default.createElement("button", { key: preset.id, className: Profiles_less_1.default['picker-item'], title: preset.id, style: { backgroundColor: preset.bg }, onClick: function () { return setAvatar(picking, "preset:".concat(preset.id)); } },
                        react_1.default.createElement("span", { role: 'img', "aria-hidden": true }, preset.emoji))); })),
                    react_1.default.createElement("div", { className: Profiles_less_1.default['picker-actions'] },
                        react_1.default.createElement("label", { className: Profiles_less_1.default['btn'] },
                            "Upload image",
                            react_1.default.createElement("input", { type: 'file', accept: 'image/*', style: { display: 'none' }, onChange: function (e) {
                                    var f = e.target.files && e.target.files[0];
                                    if (f && picking)
                                        uploadAvatar(picking, f);
                                    e.target.value = '';
                                } })),
                        react_1.default.createElement(components_1.Button, { className: Profiles_less_1.default['btn'], onClick: function () { return setAvatar(picking, ''); } }, "Reset to initial"),
                        react_1.default.createElement(components_1.Button, { className: Profiles_less_1.default['btn'], onClick: function () { return setPicking(null); } }, "Close")))),
        react_1.default.createElement("div", { className: Profiles_less_1.default['create'] },
            react_1.default.createElement("input", { className: Profiles_less_1.default['input'], type: 'text', value: newName, placeholder: 'New profile name', maxLength: 40, onChange: function (e) { return setNewName(e.target.value); }, onKeyDown: function (e) { if (e.key === 'Enter')
                    create(); } }),
            react_1.default.createElement(components_1.Button, { className: Profiles_less_1.default['btn'], disabled: busy || !newName.trim(), onClick: create }, "Add profile"))));
});
Profiles.displayName = 'Profiles';
exports.default = Profiles;
